import { createContext } from 'react';
import { type ClipboardImageValidatorErrorTranslationKey, type ImageUploadErrorTranslationKey } from './plugins';

export type PluginErrorTranslationKey = ClipboardImageValidatorErrorTranslationKey | ImageUploadErrorTranslationKey;

type ColorTranslationKey = 'black' | 'blue' | 'gray' | 'green' | 'orange' | 'red';

type RichTextEditorConfig = {
  onError: (message: string) => void;
  translations: {
    colors: Record<ColorTranslationKey, string>;
    errors: Record<PluginErrorTranslationKey, string>;
  };
};

export const RichTextEditorContext = createContext<RichTextEditorConfig>({
  onError: console.error,
  translations: {
    colors: {
      black: 'Black',
      blue: 'Blue',
      gray: 'Gray',
      green: 'Green',
      orange: 'Orange',
      red: 'Red',
    },
    errors: {
      fileAccessFailed: 'An error has occurred while accessing file.',
      fileUploadFailed: 'An error has occurred while uploading file.',
      fileUploadAborted: 'An error has occurred while uploading file.',
      sourceValidationFailed: 'An error has occurred while pasting file from clipboard.',
    },
  },
});

export const RichTextEditorProvider = RichTextEditorContext.Provider;
